module.exports = __webpack_public_path__ + "img/gift.bb7b190.png";